module.exports = __webpack_public_path__ + "static/media/thank-you-notes-alt.fddfa3c6.svg";